import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

interface LocationState {
  score: number;
  total: number;
}

const Result = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;
  
  useEffect(() => {
    // Record the session results
    const recordSession = async () => {
      if (!auth.currentUser || !state) return;
      
      const sessionId = `session_${Date.now()}`;
      const xpEarned = state.score * 10; // 10 XP per correct answer
      
      await setDoc(doc(db, 'sessions', sessionId), {
        uid: auth.currentUser.uid,
        timestamp: new Date(),
        score: state.score,
        total: state.total,
        xpEarned
      });
    };
    
    recordSession();
  }, [state]);
  
  if (!state) {
    // Redirect if no results data
    navigate('/');
    return null;
  }
  
  const percentage = Math.round((state.score / state.total) * 100);
  
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="max-w-md w-full p-6 bg-white rounded-lg shadow-lg text-center">
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Quiz Results
        </h1>
        
        <div className="mb-6">
          <div className="text-5xl font-bold mb-2">{percentage}%</div>
          <p className="text-xl">
            You got {state.score} out of {state.total} correct!
          </p>
          <p className="mt-2 text-green-600 font-semibold">
            +{state.score * 10} XP earned
          </p>
        </div>
        
        <div className="space-y-4">
          <button 
            onClick={() => navigate('/quiz')}
            className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
          >
            Try Another Quiz
          </button>
          
          <button 
            onClick={() => navigate('/profile')}
            className="w-full bg-gray-200 text-gray-800 py-2 rounded hover:bg-gray-300"
          >
            View Profile
          </button>
        </div>
      </div>
    </div>
  );
};

export default Result; 